<app-page-header subtitle="Bezetting">
    <div filters>
        <mat-form-field class="staffing-filter-field" appearance="outline">
            <mat-label>Weergave</mat-label>
            <mat-select [formControl]="displayModeControl">
                <mat-option [value]="StaffingDisplayMode.All">Verlof en planning</mat-option>
                <mat-option [value]="StaffingDisplayMode.Leave">Alleen verlof</mat-option>
                <mat-option [value]="StaffingDisplayMode.Planning">Alleen planning</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</app-page-header>

<div class="planning-wrapper overflow-auto position-relative small" #planningGrid [style.--days]="days.length">
    <div class="grid-header position-sticky top-0">
        <div class="grid-row d-grid">
            <div class="cell corner-cell position-sticky start-0 py-1"></div>

            @for (week of weeks; track week.key) {
                <div
                    class="cell week-header d-flex align-items-center justify-content-center text-center gap-1 px-1 py-1 lh-sm">
                    <span class="fw-semibold">Week {{ week.weekNumber }}</span>
                    <small class="week-range">{{ week.rangeLabel }}</small>
                </div>
            }
        </div>

        <div class="grid-row d-grid">
            <div
                class="cell name-header position-sticky start-0 d-flex align-items-center justify-content-center text-center fw-semibold py-2">
                Medewerker
            </div>

            @for (day of days; track day.dateKey) {
                <div
                    class="cell d-flex flex-column align-items-center justify-content-center small"
                    [class.day-header-weekend]="day.isWeekend"
                    [attr.data-day-key]="day.dateKey">
                    <div>{{ day.dayLabel }}</div>
                    <div class="fw-semibold">{{ day.dayNumber }}</div>
                </div>
            }
        </div>
    </div>

    <div class="grid-body small">
        @for (uniqueRole of uniqueRoles; track uniqueRole.key) {
            <div class="grid-row d-grid">
                <div class="cell role-name d-flex align-items-center">
                    <span class="position-sticky start-0 px-2 py-1">
                        {{ uniqueRole.name }}
                    </span>
                </div>
            </div>

            @for (user of uniqueRole.users; track user.id) {
                <div class="grid-row d-grid">
                    <div
                        class="cell name-cell position-sticky start-0 d-flex align-items-center px-2 py-1 overflow-hidden text-truncate"
                        [attr.data-user-id]="user.id">
                        {{ user.name }}
                    </div>

                    @for (day of days; track day.dateKey) {
                        @let item = planningByUserAndDate[user.id]?.[day.dateKey];

                        @if (item) {
                            <div
                                class="cell day-cell"
                                [class.night]="item.isNight"
                                [class.day-cell-weekend]="day.isWeekend"
                                [class.leave]="
                                    displayModeControl.value === StaffingDisplayMode.All && item.leaveIconName
                                "
                                [attr.data-user-id]="user.id"
                                [attr.data-day-key]="day.dateKey"
                                [title]="item.title"
                                [cdkContextMenuTriggerFor]="context_menu"
                                (contextmenu)="onCellContextMenu(user, day)">
                                <div
                                    class="d-flex align-items-center justify-content-center h-100 overflow-hidden gap-1">
                                    @if (item.leaveIconName && displayModeControl.value === StaffingDisplayMode.Leave) {
                                        <i class="fa-regular {{ item.leaveIconName }}"></i>
                                    }

                                    @if (item.entityTypeIcon || item.projectIcon) {
                                        @if (item.entityTypeIcon) {
                                            <i class="fa-regular fa {{ item.entityTypeIcon }}"></i>
                                        } @else {
                                            <mat-icon>{{ item.projectIcon }}</mat-icon>
                                        }

                                        @if (item.extraPlanningCount > 0) {
                                            <small class="day-count-badge lh-1 text-truncate">
                                                +{{ item.extraPlanningCount }}
                                            </small>
                                        }
                                    }
                                </div>
                            </div>
                        } @else {
                            <div
                                class="cell day-cell"
                                [class.day-cell-weekend]="day.isWeekend"
                                [attr.data-user-id]="user.id"
                                [attr.data-day-key]="day.dateKey"></div>
                        }
                    }
                </div>
            }
        }
    </div>
</div>

<ng-template #context_menu>
    <div class="context-menu" cdkMenu>
        <button class="menu-item info" (click)="showInfoDialog()" cdkMenuItem>
            <i class="fa-regular fa-memo-circle-info"></i> Details dag
        </button>
    </div>
</ng-template>
